import styled, { css } from 'styled-components';

import { NARROW_CONTAINER_WIDTH } from '@components/blocks';
import { media } from '@theme/media';
import { COLORS } from '@theme/colors';
import { FONT_SIZE, typography } from '@theme/font';

const textStylesFeatured = css`
  ${typography({ size: FONT_SIZE.M })};

  ${media.tablet} {
    ${typography({ size: FONT_SIZE.L })};
  }
`;

export const Container = styled.div`
  width: 100%;
  padding-top: 120px;
  padding-bottom: 120px;

  ${media.tablet} {
    padding-top: 200px;
    padding-bottom: 200px;
  }
`;

export const CurrentGalleries = styled.div`
  padding: 0 50px 100px;
  margin: 0 auto;
  text-align: center;
`;

export const GalleriesCopy = styled.span`
  padding: 8px 0;
  margin-right: 14px;
  text-transform: uppercase;
`;

const sideMargin = 18;
const gap = 36;

export const AlphabetContainer = styled.div`
  margin: 0 auto;
  padding: 0 ${sideMargin}px;
  display: flex;
  column-gap: ${gap}px;
  row-gap: ${gap * 3}px;
  max-width: 576px;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 0 ${sideMargin}px;
`;

export const GalleryLink = styled.a`
  ${textStylesFeatured};
  text-align: center;
  color: ${COLORS.BLACK};
  text-decoration: none;
  display: block;
  overflow: hidden;
`;

export const AllGalleries = styled.div`
  padding: 72px 50px 100px;
  text-align: center;

  ${media.mobile} {
    padding: 200px 50px 100px;
  }
`;

export const GalleriesList = styled.div`
  max-width: ${NARROW_CONTAINER_WIDTH}px;
  margin: 0 21px;

  ${media.tablet} {
    margin: 0 auto;
  }
`;
